import { loginAPI } from "../../../apis/LoginAPI.jsx";

export default class TwoStepVerificationService {
  confirmEmail(token, setState) {
    loginAPI
      .confirmEmail(token)
      .then((response) => {
        if (response.status === 200) {
          //Success
          var arrays = response.data.payload.split(" ");
          var cutEmail = arrays[arrays.length - 1].slice(3);

          setState({
            message: "**" + cutEmail,
            loadingEmail: false,
          });
        } else {
          //Failure
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
      });
  }

  validateEmail(token, code, setState, setMessages, getClientConfig) {
    loginAPI
      .validateEmail(token, code)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          //Success
          getClientConfig();
          setState({
            loadingSent: false,
            stage: 2,
          });
        } else {
          //Failure
          setMessages("the-code-you-entered-is-incorrect");
          setState({
            invalidCode: true,
            loadingSent: false,
          });
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
        setMessages("the-code-you-entered-is-incorrect");
        setState({
          invalidCode: true,
          loadingSent: false,
        });
      });
  }
}
